export const setActiveCouncil = id => {
  return {
    type: 'COUNCIL:SET_ACTIVE',
    payload: { id },
  };
};

export const setComparedCouncil = id => {
  return {
    type: 'COUNCIL:SET_COMPARED',
    payload: { id },
  };
};

export const setActivePage = name => {
  return {
    type: 'PAGE:SET_ACTIVE',
    payload: { name },
  };
};
export const setIsMobile = isMobile => {
  return {
    type: 'SET_IS_MOBILE',
    payload: isMobile,
  };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js